import { render, staticRenderFns } from "./PvCenterColumn.vue?vue&type=template&id=d5a9eba4&"
import script from "./PvCenterColumn.vue?vue&type=script&lang=js&"
export * from "./PvCenterColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports